import React from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { TextBodyContent } from "./components/TextBodyContent";
import { useTextData } from "./hooks/useTextData";
import "./TextTemplate.scss";

export function TextTemplate(props: QRProps<"text">) {
  const { message, isInitPreview } = useTextData(props);

  return (
    <div className="text-template">
      <PhoneLayout
        page="text"
        dataQA="preview-text-container"
        backgroundColor="white"
        isInitPreview={isInitPreview}
      >
        <TextBodyContent message={message} />
      </PhoneLayout>
    </div>
  );
}
